<template>
    <div>
      <a-card :bordered="false" :bodyStyle="tstyle">
        <div class="table-page-search-wrapper" v-if="hasPerm('viewRegisterComment:page')">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="挂号id">
                  <a-input v-model="queryParam.registerId" allow-clear placeholder="请输入挂号id" />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="评分">
                  <a-input v-model="queryParam.commentLevel" allow-clear placeholder="请输入评分" />
                </a-form-item>
              </a-col>
              <template v-if="advanced">
                <a-col :md="8" :sm="24">
                  <a-form-item label="评价时间">
                    <a-date-picker style="width: 100%" placeholder="请选择评价时间" v-model="ctstampDate"
                      @change="onChangectstamp" />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="评价人">
                    <a-input v-model="queryParam.username" allow-clear placeholder="请输入评价人" />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="评价人id">
                    <a-input v-model="queryParam.userId" allow-clear placeholder="请输入评价人id" />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="科室">
                    <a-input v-model="queryParam.deptname" allow-clear placeholder="请输入科室" />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="医生">
                    <a-input v-model="queryParam.regDoctorname" allow-clear placeholder="请输入医生" />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="就诊人id">
                    <a-input v-model="queryParam.patientid" allow-clear placeholder="请输入就诊人id" />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="就诊人姓名">
                    <a-input v-model="queryParam.patientname" allow-clear placeholder="请输入就诊人姓名" />
                  </a-form-item>
                </a-col>
              </template>
              <a-col :md="8" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                  <a-button style="margin-left: 8px" @click="reset()">重置</a-button>
                  <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </a-card>
      <a-card :bordered="false">
        <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert" :rowKey="(record) => record.id"
          :rowSelection="options.rowSelection">
          <template class="table-operator" slot="operator" v-if="hasPerm('viewRegisterComment:add')">
            <!-- <a-button type="primary" v-if="hasPerm('viewRegisterComment:add')" icon="plus" @click="$refs.addForm.add()">
              新增复诊挂号评价</a-button> -->
            <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('viewRegisterComment:delete')"
              @click="batchDelete">
              <a-icon type="delete" />批量删除
            </a-button>
            <x-down v-if="hasPerm('viewRegisterComment:export')" ref="batchExport" @batchExport="batchExport" />
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="$refs.addForm.add(record)">详情</a>
            <!-- <a-divider type="vertical" v-if="hasPerm('viewRegisterComment:edit') & hasPerm('viewRegisterComment:delete')"/>
            <a-popconfirm v-if="hasPerm('viewRegisterComment:delete')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)">
              <a>删除</a>
            </a-popconfirm> -->
          </span>
        </s-table>
        <add-form ref="addForm" @ok="handleOk" />
        <edit-form ref="editForm" @ok="handleOk" />
      </a-card>
    </div>
  </template>
  <script>
    import { STable, XDown } from '@/components'
    import moment from 'moment'
    import { viewRegisterCommentPage, viewRegisterCommentDelete, viewRegisterCommentExport } from '@/api/modular/interhospital/viewregistercomment/viewRegisterCommentManage'
    import addForm from './addForm.vue'
    import editForm from './editForm.vue'
    export default {
      components: {
        STable,
        addForm,
        editForm,
        XDown
      },
      data () {
        return {
          // 高级搜索 展开/关闭
          advanced: false,
          // 查询参数
          queryParam: {},
          // 表头
          columns: [
            {
              title: '挂号id',
              align: 'center',
              dataIndex: 'registerId'
            },
            {
              title: '就诊人姓名',
              align: 'center',
              dataIndex: 'patientname'
            },
            {
              title: '评价时间',
              align: 'center',
              dataIndex: 'ctstamp'
            },
            {
              title: '科室',
              align: 'center',
              dataIndex: 'deptname'
            },
            {
              title: '医生',
              align: 'center',
              dataIndex: 'regDoctorname'
            },
            {
              title: '医生服务',
              align: 'center',
              dataIndex: 'commentLevel'
            },
            {
              title: '问诊流程',
              align: 'center',
              dataIndex: 'processScore'
            },
            {
              title: '物流服务',
              align: 'center',
              dataIndex: 'deliverScore'
            },
          ],
          tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
          // 加载数据方法 必须为 Promise 对象
          loadData: parameter => {
            return viewRegisterCommentPage(Object.assign(parameter, this.switchingDate(),{type:1})).then((res) => {
              return res.data
            })
          },
          selectedRowKeys: [],
          selectedRows: [],
          options: {
            alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
            rowSelection: {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            }
          },
          ctstampDate: null
        }
      },
      created () {
        if (this.hasPerm('viewRegisterComment:edit') || this.hasPerm('viewRegisterComment:delete')) {
          this.columns.push({
            title: '操作',
            width: '150px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          })
        }
      },
      methods: {
        moment,
        /**
         * 查询参数组装
         */
        switchingDate () {
          const queryParamctstamp = this.ctstampDate
          if (queryParamctstamp != null) {
              this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
              if (queryParamctstamp.length < 1) {
                  delete this.queryParam.ctstamp
              }
          }
          const obj = JSON.parse(JSON.stringify(this.queryParam))
          return obj
        },
        reset(){
          this.queryParam = {}
          this.ctstampDate = null
        },
        /**
         * 单个删除
         */
        singleDelete (record) {
          const param = [{ 'id': record.id }]
          this.viewRegisterCommentDelete(param)
        },
        /**
         * 批量删除
         */
        batchDelete () {
          const paramIds = this.selectedRowKeys.map((d) => {
              return { 'id': d }
          })
          this.viewRegisterCommentDelete(paramIds)
        },
        viewRegisterCommentDelete (record) {
          viewRegisterCommentDelete(record).then((res) => {
            if (res.success) {
              this.$message.success('删除成功')
              this.$refs.table.clearRefreshSelected()
            } else {
              this.$message.error('删除失败') // + res.message
            }
          })
        },
        toggleAdvanced () {
          this.advanced = !this.advanced
        },
        onChangectstamp(date, dateString) {
          this.ctstampDateString = dateString
        },
        /**
         * 批量导出
         */
        batchExport () {
          // const paramIds = this.selectedRowKeys.map((d) => {
          //     return { 'id': d }
          // })
          const paramIds = {
            type: '1'
          }
          viewRegisterCommentExport(paramIds).then((res) => {
              this.$refs.batchExport.downloadfile(res)
          })
        },
        handleOk () {
          this.$refs.table.refresh()
        },
        onSelectChange (selectedRowKeys, selectedRows) {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        }
      }
    }
  </script>
  <style lang="less">
    .table-operator {
      margin-bottom: 18px;
    }
    button {
      margin-right: 8px;
    }
    .ant-tabs-bar{
        margin:0;
        padding: 16px 16px 16px;
        background: #fff;
      }
  </style>
  